import(/* webpackMode: "eager" */ "/codebuild/output/src669793838/src/kozoka-v2r/frontend/app/(main)/page.tsx");
